import { HMDALoanType } from './HMDALoanType';

export const HMDALoanTypeOptions = [
    {
        id: HMDALoanType.BuildRent,
        name: 'Build Rent',
    },
    {
        id: HMDALoanType.Rental,
        name: 'Rental',
    },
    {
        id: HMDALoanType.FixFlip,
        name: 'Fix-Flip',
    },
    {
        id: HMDALoanType.SubNoteFixFlip,
        name: 'Fix-Flip-LOC',
    },
    {
        id: HMDALoanType.Bridge,
        name: 'Bridge',
    },
];
